module.exports = __webpack_public_path__ + "static/media/acramite_50ws.b1fa0987.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/manzano/climasense/acaro_manzano/curativa/acramite_50ws.png
// module id = 1741
// module chunks = 3